<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-with-title heading-without-image" id="chapter-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">1</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">T</span>here were three of them by the graveside, but not one of them mourned. At the head of the grave stood the minister. He was in his late sixties and weather-beaten from decades of service. The elderly man shifted and cleared his throat but there was little to say. Although he knew that what they were doing was surely unethical, he had not asked questions.</p>
<p class="subsq">The cemetery was newish, sited high up on the outskirts of the town. Some of the locals had complained about the necessity to erect one. It wasn’t like the old days when every Scottish family bought a plot, choosing their final resting place beside a long line of forefathers. People were done with those kinds of traditions now. They wanted a cheap, clean funeral. They no longer sought solace in religion at all.</p>
<p class="subsq">But the small, grey church with its graveyard was there, all the same. It was secluded as was necessary, with high metal gates. There were no houses within sight and few walked up this far, especially when the nights were drawing in. Below them, the lines of orange street lamps lit the roadsides. Car headlights moved in a convoluted serpent as commuters made their way home to warm kitchens and eager loved ones, unaware of the solemn proceedings close by.</p>
<p class="subsq">It was almost dusk and a thin drizzle hung in the air. It had been threatening to rain all day. Not heavy enough to warrant an overcoat, but just sufficient to thoroughly chill the suited men. They stood now, heads bowed and shoulders hunched until the minister was done with his obligatory words. One of the men coughed and rubbed his neck. His colleague glanced sideways, momentarily studying the other’s face. Neither spoke.</p>
<p class="subsq">The edges of the grave had not been covered with the customary green cloth as would have been usual for a burial. Instead, due to the haste of the arrangements, the grave had been dug that evening by the sexton. The sides of the earth were sharp and damp, cut deep into the red-brown clay of the land. The mechanical digger rested nearby, an irreverent and garish bystander. The coffin bore no name and only a simple, square headstone would mark it eventually. The inscription would be vague.</p>
<p class="subsq">Afterwards, they didn’t linger. One of the suited men shook the minister’s hand. They made their way back to their black saloon. The minister watched as the car pulled out of the cemetery and onto the glistening tarmac. The wheels swished. He stood and listened to the drone of the car engine until it joined the chorus of the other cars far below. Slowly, he made his way back to the church.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?5a9e739b